import classNames from "classnames"
import React from "react"

import { PNImage } from "@bounce/web-components"

import { useMetrics } from "../hooks/useMetrics"

export type MetricsListProps = {
  className?: string
}

export const MetricsList = ({ className }: MetricsListProps) => {
  const metrics = useMetrics()

  return (
    <section className={classNames("mx-auto w-full max-w-screen-xl", className)}>
      <ul className="grid px-6 sm:grid-cols-2 lg:grid-cols-4">
        {metrics.map(({ src, text }, i) => (
          <li className="mb-9 flex items-center" key={"step-" + i}>
            <PNImage
              src={src}
              height={60}
              width={60}
              loading="lazy"
              imgixParams={{ fit: "max", h: 60 }}
              className="mr-6 size-[60px] object-contain lg:size-[80px]"
            />
            <div>{text}</div>
          </li>
        ))}
      </ul>
    </section>
  )
}
